// extracted by mini-css-extract-plugin
export var hideEditor = "_s2-2";
export var infoIcon = "_s2-3";
export var label = "_s2-1";
export var labelContainer = "_s2-0";
export var readonlyText = "_s2-4";